<template>
  <b-card no-body class="nft-item">
    <span class="top-icon"></span>
    <router-link to="#">
      <b-card-img
        v-if="info && info.image"
        class="nft-image"
        v-bind:src="info.image"
        alt="image"
      ></b-card-img>
      <b-skeleton-img v-else></b-skeleton-img>
      <b-card-body class="is-flex">
        <div class="nft-head">
          <b-card-title
            v-if="((info && info.name) || tokenId) && !isLoading"
            class="nft-title"
          >
            <span>{{ utils.truncate(info.name) }}</span>
          </b-card-title>
          <b-skeleton v-else type="button" animation="fade"></b-skeleton>
        </div>
        <div class="nft-owner text-overlay" v-if="info && info.rate !== null">
          <b-card-text class="owner-text">Rate</b-card-text>
          <b-card-title class="owner-value"> {{ info.rate }} %</b-card-title>
        </div>
      </b-card-body>
    </router-link>
  </b-card>
</template>
<script>
export default {
  name: "CardSaruSkeleton",
  props: ["tokenId", "info"],
  data: () => ({
    isLoading: true,
  }),
  updated: async function () {
    this.$nextTick().then(() => {
      let nftImg = document.querySelector(".nft-image");
      if (nftImg) {
        if (nftImg.naturalWidth < 200) {
          this.isPixelated = true;
        } else {
          this.isPixelated = false;
        }
      }
    });
  },
};
</script>
<style scoped lang="scss">
.nft-item {
  min-width: 297px;
  background-color: transparent;
  border-color: transparent;
  transition: all 0.35s ease;
  cursor: pointer;
  .top-icon {
    height: 8px;
    width: 40%;
    transform: skew(-50deg);
    display: block;
    background-color: #552d65;
    position: absolute;
    left: 28%;
    top: 0;
  }
  // &:hover{
  //     background-color: #fff;
  //     box-shadow: 0px 0px 8px 2px #e9e9e9;
  // }
  &:before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 0;
    left: 0;
    display: block;
    background: #434048;
    clip-path: polygon(
      calc(68% - 1px) calc(4% - 2px),
      calc(74% - 3px) 0,
      calc(93% + 2px) 0,
      100% calc(5% - 4px),
      100% calc(94% + 4px),
      calc(94% + 2px) 100%,
      0 100%,
      0px calc(10% - 3px),
      calc(11% - 1px) calc(4% - 2px)
    );
  }
  > a {
    color: inherit;
    position: relative;
    clip-path: polygon(
      68% 4%,
      74% 0,
      93% 0,
      100% 5%,
      100% 94%,
      94% 100%,
      0 100%,
      0 10%,
      11% 4%
    );
    border: 2px solid #434048;
    background-color: #16101c;
    border-radius: 0;
    padding-left: 15px;
    padding-right: 15px;
    &:hover {
      text-decoration: none;
    }
    img {
      margin-top: 45px;
    }
    .b-skeleton-img {
      margin-top: 45px;
      height: 260px;
    }
  }
  .b-skeleton {
    background-color: rgb(88 88 88 / 25%);
    margin-bottom: 0;
  }
  .rental {
    position: absolute;
    right: 10%;
    z-index: 1000;
    top: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #eb345f;
  }
  .nft-point-text,
  .nft-materials-text {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &:hover {
    &:before {
      background-color: #fff;
    }
    .top-icon {
      background-color: #eb345f;
    }
    > a {
      border-color: #fff;
    }
    .nft-point-text,
    .nft-materials-text {
      color: #fff;
    }
    .nft-title,
    .owner-value,
    .point,
    .percent {
      color: #eb345f;
    }
  }
  .card-body {
    padding: 16px 0;
    border-bottom: 1px solid #434048;
  }
  .point,
  .percent {
    font-size: 24px;
    font-weight: bold;
  }
  .is-flex {
    justify-content: space-between;
  }
  .nft-head {
    width: 61%;
  }
  .nft-owner {
    width: 39%;
  }
  .nft-acc {
    font-size: 12px;
    margin-bottom: 0;
    color: #66636a;
    font-weight: 600;
    line-height: 16px;
  }
  .nft-title {
    font-size: 30px;
    margin-bottom: 0;
  }
  .nft-index {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .owner-text {
    font-size: 12px;
    margin-bottom: 0;
    font-weight: 600;
    text-align: right;
    color: #66636a;
  }
  .owner-value {
    font-size: 16px;
    text-align: right;
    margin-bottom: 0;
  }
  @media (max-width: 560px) {
    width: calc(100% - 20px) !important;
    > a {
      img {
        margin-top: 55px;
      }
    }
  }
}
</style>
